import { BasePlugin } from '../base'
import mdcToolbar from './mdc-toolbar.vue'
import mdcToolbarRow from './mdc-toolbar-row.vue'
import mdcToolbarSection from './mdc-toolbar-section.vue'
import mdcToolbarMenuIcon from './mdc-toolbar-menu-icon.vue'
import mdcToolbarTitle from './mdc-toolbar-title.vue'
import mdcToolbarIcon from './mdc-toolbar-icon.vue'

export {
  mdcToolbar,
  mdcToolbarRow,
  mdcToolbarSection,
  mdcToolbarMenuIcon,
  mdcToolbarTitle,
  mdcToolbarIcon
}

export default BasePlugin({
  mdcToolbar,
  mdcToolbarRow,
  mdcToolbarSection,
  mdcToolbarMenuIcon,
  mdcToolbarTitle,
  mdcToolbarIcon
})
